import { createFileRoute, Link, Outlet, useMatches } from '@tanstack/react-router'
import {
  Inbox, AlertCircle, CheckCircle, XCircle, Puzzle, Bot,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'

const OPS_INBOX_TABS = [
  { to: '/ops-inbox/all', segment: 'all', label: 'opsInbox.tabAll', icon: Inbox },
  { to: '/ops-inbox/exceptions', segment: 'exceptions', label: 'opsInbox.tabExceptions', icon: AlertCircle },
  { to: '/ops-inbox/approvals', segment: 'approvals', label: 'opsInbox.tabApprovals', icon: CheckCircle },
  { to: '/ops-inbox/failed-operations', segment: 'failed-operations', label: 'opsInbox.tabFailedOps', icon: XCircle },
  { to: '/ops-inbox/custom-slot-approvals', segment: 'custom-slot-approvals', label: 'opsInbox.tabCustomSlots', icon: Puzzle },
  { to: '/ops-inbox/ai-action-reviews', segment: 'ai-action-reviews', label: 'opsInbox.tabAIReviews', icon: Bot },
] as const

export const Route = createFileRoute('/_authenticated/ops-inbox')({
  component: OpsInboxLayout,
})

function OpsInboxLayout() {
  const { t } = useTranslation()
  const matches = useMatches()
  const activeTab = matches[matches.length - 1]?.routeId?.split('/').pop() ?? 'all'

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">{t('opsInbox.title', 'Operations Inbox')}</h1>
        <p className="text-muted-foreground">{t('opsInbox.description', 'Manage exceptions, approvals, and operational issues')}</p>
      </div>

      <div className="flex gap-1 border-b">
        {OPS_INBOX_TABS.map(tab => (
          <Link
            key={tab.to}
            to={tab.to}
            className={cn(
              'flex items-center gap-1.5 px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors',
              activeTab === tab.segment
                ? 'border-primary text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground',
            )}
          >
            <tab.icon className="w-4 h-4" />
            {t(tab.label, tab.segment)}
          </Link>
        ))}
      </div>

      <Outlet />
    </div>
  )
}
